import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-study-details',
    templateUrl: './study-details.component.html',
    styleUrls: ['./study-details.component.scss'],
    standalone: false
})
export class StudyDetailsComponent implements OnInit {
   @ViewChild("mainContent", { static: false }) mainContent!: ElementRef;
  //In study Receving Rowdata from study Library
  study: any;
  //Recevies studyId from url path 
  studyId

    sections = [
    { key: "details", title: "Details" },
    { key: "studyArm", title: "Study Arm" },
    { key: "studyProduct", title: "Study Product" },
    { key: "indication", title: "Indications" },
    { key: "Registration", title: "Registration" },
  ];
  sectionVisibility: any = {};
  activeSection = "details";
  private scrollListener!: () => void;
  responserequest;

  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  gridApi;

  gridColumnApi;

  components;
  rowbindingdata;

  options: any;

  gridOptions = {
    animateRows: true,
    enableSorting: true,
    enableCellChangeFlash: true,
    context: { componentParent: this },
    rowHeight :35
  };

  // Default AG-Grid behaviour
  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
  };
  // Column Definitions
  studyProductColumnDefs = [
    { field: "id", headerName: "id", headerTooltip: 'id',tooltipValueGetter: (params) =>'id: ' + params.value, },
    { field: "name__v", headerName: "Name", headerTooltip: 'Name',tooltipValueGetter: (params) =>'Name: ' + params.value, },
    { field: "study_product_role__v", headerName: "Study Product Role", headerTooltip: 'Study Product Role',tooltipValueGetter: (params) =>'Study Product Role: ' + params.value, },
    { field: "dose_number__v", headerName: "Dose", headerTooltip: 'Dose',tooltipValueGetter: (params) =>'Dose: ' + params.value, },
    { field: "dose_unit_text__v", headerName: "Dose(Unit)", headerTooltip: 'Dose(Unit)',tooltipValueGetter: (params) =>'Dose(Unit): ' + params.value, },
  ];

  studyArmColumnDefs = [
    { field: "id", headerName: "id" , headerTooltip: 'id',tooltipValueGetter: (params) =>'id: ' + params.value, },
    { field: "name__v", headerName: "Name", headerTooltip: 'Name',tooltipValueGetter: (params) =>'name: ' + params.value,  },
    { field: "blinded__v", headerName: "Blinded", headerTooltip: 'Blinded',tooltipValueGetter: (params) =>'blinded: ' + params.value,  },
    { field: "description__v", headerName: "Description", headerTooltip: 'Description',tooltipValueGetter: (params) =>'Description: ' + params.value,  },
  ];

  indicationColumnDefs = [
    { field: "id", headerName: "id" , headerTooltip: 'id',tooltipValueGetter: (params) =>'id: ' + params.value,},
    { field: "name__v", headerName: "Name", headerTooltip: 'Name',tooltipValueGetter: (params) =>'Name: ' + params.value, },
    { field: "indication_meddra__v", headerName: "Indication medDRA", headerTooltip: 'Indication medDRA',tooltipValueGetter: (params) =>'Indication medDRA: ' + params.value, },
  ];
    RegistrationColumnDefs = [
    { field: "id", headerName: "id" , headerTooltip: 'id',tooltipValueGetter: (params) =>'id: ' + params.value,},
    { field: "name__v", headerName: "Name", headerTooltip: 'Name',tooltipValueGetter: (params) =>'Name: ' + params.value, },
    { field: "registration_number__v", headerName: "Study Registration Nmber", headerTooltip: 'Study Registration Number',tooltipValueGetter: (params) =>'Study Registration Number: ' + params.value, },
    { field: "country__v_name__v", headerName: "Country", headerTooltip: 'Country',tooltipValueGetter: (params) =>'Country: ' + params.value, },
  ];
  // Row Data (filled after mock "API")
  therapyRowData: any[] = [];
  administrationRowData: any[] = [];
  literatureRowData: any[] = [];
  deviceRowData: any[] = [];
  backgroundColorScreen: string;
  backgroundColorButton: string;
studyProductData: any;
studyArmRowData: any;
indicationRowData: any;
RegistrationRowData: any;

  constructor( private localStorage: LocalStorageSettingsService,
    private jsignalsService: JsignalService,
      private route: ActivatedRoute,
      private router: Router,
      private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,) { }

  ngOnInit(): void {
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");

    this.sections.forEach(
      (s) => (this.sectionVisibility[s.key] = s.key === "details")
    );

      this.route.paramMap.subscribe((params) => {
      this.studyId = params.get("studyId")!;

      if(!this.studyId){
        console.error("No studyId found in route");
        this.goBack();
        return;
      }
      
      console.log(this.studyId);
      // this.loadProductMock(this.productId);
      this.loadStudyDetails(this.studyId);
      this.loadStudyProducts(this.studyId);
      this.loadStudyArms(this.studyId);
      this.loadStudyIndications(this.studyId);
      this.loadStudyRegistrations(this.studyId);
    });
   
  }

    ngAfterViewInit() {
    this.scrollListener = this.updateActiveSection.bind(this);
    this.mainContent.nativeElement.addEventListener(
      "scroll",
      this.scrollListener
    );

    setTimeout(() => this.updateActiveSection(), 100);
  }

  ngOnDestroy() {
    if (this.scrollListener && this.mainContent) {
      this.mainContent.nativeElement.removeEventListener(
        "scroll",
        this.scrollListener
      );
    }
  }

   // ------------------ SECTION TOGGLE & SCROLL ------------------

  toggleSection(key: string) {
    this.sectionVisibility[key] = !this.sectionVisibility[key];
  }

  scrollToSection(key: string) {
    const el = document.getElementById(key);
    if (!el) return;

    const container = this.mainContent.nativeElement;
    const containerRect = container.getBoundingClientRect();
    const rect = el.getBoundingClientRect();

    container.scrollTo({
      top: rect.top - containerRect.top + container.scrollTop - 50,
      behavior: "smooth",
    });

    this.activeSection = key;
    this.sectionVisibility[key] = true;
  }

  private updateActiveSection() {
    const container = this.mainContent.nativeElement;
    const containerRect = container.getBoundingClientRect();

    let bestMatch = this.sections[0].key;
    let maxVisible = 0;

    for (let s of this.sections) {
      const el = document.getElementById(s.key);
      if (!el) continue;

      const rect = el.getBoundingClientRect();
      const visibleTop = Math.max(rect.top, containerRect.top);
      const visibleBottom = Math.min(rect.bottom, containerRect.bottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);
      const visibilityRatio = visibleHeight / rect.height;

      if (visibilityRatio > maxVisible) {
        maxVisible = visibilityRatio;
        bestMatch = s.key;
      }
    }

    this.activeSection = bestMatch;
  }

  onstudyProductGridReady(params){

  }

  onstudyArmGridReady(params){

  }
  onindicationGridReady(params){

  }
  onRegistrationGridReady(params){

  }

  goBack() {
    this.router.navigate(["../../"], { relativeTo: this.route });
  }

  onCreateStudyArm() {
  // open dialog / add new row / form logic here
  console.log("Create Study Arm clicked");
}

loadStudyDetails(studyId: any) {
   this.spinner.start();
    this.jsignalsService.getStudyDetailsById(studyId).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.study = response;
        console.log("Fetched study details:", this.study);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching study details:", error);
        this.snackBar.open("Failed to load study details", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
}

loadStudyProducts(studyId: any) {
this.spinner.start();
    this.jsignalsService.getStudyProductsById(studyId).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.studyProductData = response;
        console.log("Fetched study products:", this.studyProductData);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching study products:", error);
        this.snackBar.open("Failed to load study products", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
}

loadStudyArms(studyId: any) {
  this.spinner.start();
    this.jsignalsService.getStudyArmsById(studyId).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.studyArmRowData = response;
        console.log("Fetched study arms:", this.studyArmRowData);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching study arms:", error);
        this.snackBar.open("Failed to load study arms", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
}

loadStudyIndications(studyId: any) {
  this.spinner.start();
    this.jsignalsService.getStudyIndicationsById(studyId).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.indicationRowData = response;
        console.log("Fetched study indications:", this.indicationRowData);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching study indications:", error);
        this.snackBar.open("Failed to load study indications", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
}

loadStudyRegistrations(studyId: any) {
  this.spinner.start();
    this.jsignalsService.getStudyRegistrationsById(studyId).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.RegistrationRowData = response;
        console.log("Fetched study registrations:", this.RegistrationRowData);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching study registrations:", error);
        this.snackBar.open("Failed to load study registrations", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
}


}
